var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alert)?_c('div',[_c('v-alert',{attrs:{"outlined":"","dense":"","type":_vm.alert.type}},[_vm._v(_vm._s(_vm.alert.message))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }